export default "__VITE_ASSET__ToCX7G9Y__"